<template>
  <!-- 视频点播 -->
  <div v-if="isPC" class="content-area" :style="popInKr ? {height: '100%'} : {height: 'auto'}">
    <p class="vod-title" :class="popInKr ? 'in-kr-color' : ''">{{currentLang === 'en' ? 'Vod List' : '视频点播'}}</p>
    <div class="sub-wrapper">
      <div class="vod-list">
        <ul class="list-group list-group-flush" :class="popInKr ? 'in-kr-color' : ''">
          <li v-for="(item, index) of dataList" :key="item.uuid" class="list-group-item">
            <span class="vod-num vod-num-item" :class="popInKr ? 'in-kr-color' : ''">{{ index + 1 }}</span>
            <span class="vod-name" :class="popInKr ? 'in-kr-color' : ''" @click="showDetail(item)">{{item.name}}</span>
          </li>
        </ul>
      </div>
    </div>
    <LivePlayer v-if="showLive" :closeLive="closeLive" :videoUrl="videoUrl"/>
  </div>
  <div v-else class="m-content-area" :style="popInKr ? {height: '100%'} : {height: 'auto'}" id="m-content-area">
    <p class="vod-title" :class="popInKr ? 'in-kr-color' : ''">{{currentLang === 'en' ? 'Vod List' : '视频点播'}}</p>
    <div class="sub-wrapper">
      <div class="vod-list">
        <ul class="list-group list-group-flush" :class="popInKr ? 'in-kr-color' : ''">
          <li v-for="(item, index) of dataList" :key="item.uuid" class="list-group-item">
            <span class="vod-num vod-num-item" :class="popInKr ? 'in-kr-color' : ''">{{ index + 1 }}</span>
            <span class="vod-name" :class="popInKr ? 'in-kr-color' : ''" @click="showDetail(item)">{{item.name}}</span>
          </li>
        </ul>
      </div>
    </div>
    <LivePlayer v-if="showLive" :closeLive="closeLive" :videoUrl="videoUrl"/>
  </div>
</template>

<script>
import LivePlayer from '@/components/live/LivePlayer'
export default {
  name: 'VodList',
  components: { LivePlayer },
  props: ['popInKr'],
  data () {
    return {
      showLive: false,
      videoUrl: '',
      dataList: [],
    }
  },
  mounted () {
    this.initVod()
  },
  methods: {
    initVod () {
      let data = this.$allData[this.currentLang] || []
      for (let item of data) {
        if (item.showType === 'bigScreen') {
          this.dataList = item.voiceInfos.filter((i) => {
            return i.useFor === 'videolist'
          }).map((i) => {
            return {
              name: i.fileName,
              url: i.filePath,
              type: 'video'
            }
          })
          break
        }
      }
    },
    showDetail (item) {
      this.videoUrl = item.url
      this.showLive = true
    },
    closeLive () {
      this.showLive = false
    },
  }
}
</script>

<style scoped>
  .content-area {
    width:100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    text-align: center;
  }
  .vod-title {
    padding-top: 6rem;
    text-align: center;
    font-size: 14px;
    font-weight: 550;
  }
  .sub-wrapper {
    width: 80rem;
    margin: 0 auto;
  }
  .in-kr-color {
    color: #ffffff;
  }
  .vod-list {
    padding-left: 20px;
    padding-right: 20px;
  }
  .list-group-item {
    background: none;
    text-align: left;
  }
  .vod-num {
    width:10%;
    display:inline-block;
  }
  .vod-num-item {
    font-size: 20px;
    font-weight: bold;
  }
  .vod-name {
    width: 80%;
    display:inline-block;
    cursor: pointer;
  }
  #m-content-area {
    box-sizing: border-box !important;
  }
  .m-content-area {
    width: 100%;
    height: 100%;
    padding-left: 20px;
    padding-right: 20px;
    background-color: rgba(0,0,0,0.6);
  }
  .m-content-area .sub-wrapper {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
  }
  .m-content-area .nav-item {
    width:20%;
  }
  .m-content-area .nav-item span {
    font-size: 12px;
  }
  .m-content-area .vod-num {
    width: 12%;
    font-size: 14px;
  }
  .m-content-area .vod-name {
    width:80%;
    font-size: 14px;
  }
</style>